/*
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * External dependencies
 */
import { _x } from '@web-stories-wp/i18n';
import PropTypes from 'prop-types';

const title = _x('Green Leaf', 'sticker name', 'web-stories');

function GreenLeaf({ style }) {
  return (
    <svg
      style={style}
      viewBox="0 0 62 58"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>{title}</title>
      <path
        d="M8.81876 28.8347C8.59537 29.6885 8.30385 30.5547 8.23319 31.4341C8.15591 32.4239 8.16472 33.5267 8.41319 34.4792C8.68772 35.5216 8.8546 36.5859 9.29125 37.5721C9.78815 38.7027 10.3938 39.6436 11.1848 40.5896C11.6479 41.134 12.1586 41.6334 12.6068 42.2024C13.0755 42.8041 13.5046 43.4154 13.9733 44.0171C14.897 45.1987 15.7568 46.4963 16.988 47.3938C18.0445 48.158 19.1391 48.8376 20.39 49.2825C21.443 49.6541 22.5803 49.8211 23.6333 50.1927C24.2977 50.4287 24.978 50.4725 25.6056 50.7467C26.2932 51.044 27.1371 51.1065 27.8992 51.1597C28.5332 51.2022 28.9677 50.9751 29.5316 50.7123C29.7699 50.6083 30.0043 50.522 30.2426 50.4179C31.7056 49.7732 33.0574 48.7579 34.4082 47.9103C36.8919 46.3517 39.564 44.9482 41.762 43.0071C43.1666 41.7613 44.5261 40.4679 45.8023 39.0901C46.8391 37.984 47.9686 36.8805 48.7569 35.5962C49.4556 34.4594 49.8599 33.3858 50.0948 32.1149C50.2931 31.0035 50.6673 29.8577 50.7198 28.7316C50.77 27.8195 50.5612 26.9788 50.5255 26.0751C50.4731 24.9996 50.6266 23.9619 50.7419 22.8875C50.8278 22.1048 50.979 21.2812 50.9652 20.4851C50.9584 19.6999 50.8233 18.904 50.7592 18.1243C50.6699 16.9658 50.8437 15.8394 50.8293 14.6794C50.8282 14.0727 50.8707 13.4388 50.4268 12.9733C50.0526 12.5705 49.4143 12.4244 48.8703 12.3559C48.3903 12.2927 48.0601 12.1052 47.6113 11.9465C46.8201 11.6535 45.9458 11.3974 45.1194 11.2176C44.3106 11.0418 43.5979 11.1399 42.7665 11.2668C41.7199 11.4378 40.6555 11.6046 39.6033 11.7183C38.8196 11.8002 38.0344 11.8071 37.2482 11.9816C35.9305 12.2771 34.491 12.3301 33.231 12.8627C32.7147 13.0804 32.1696 13.1795 31.6369 13.3468C30.3807 13.7403 29.1534 14.2524 27.9096 14.714C26.5759 15.2018 25.2366 15.6322 23.933 16.1921C23.395 16.4235 23.0094 16.5592 22.4808 16.7087C21.5897 16.9339 20.8271 17.4124 19.9524 17.688C19.4306 17.8484 18.8718 17.9258 18.3432 18.0753C17.7246 18.2509 17.2122 18.3296 16.5782 18.2871C15.5529 18.2017 14.2266 18.29 13.3513 18.9759C12.6257 19.5375 12.0113 20.4697 11.6146 21.2652C11.2099 22.0961 10.7439 22.9503 10.5478 23.8477C10.4464 24.2909 10.1568 24.7004 9.97352 25.1342C9.75631 25.6349 9.75653 25.7563 9.64292 26.2527C9.60918 26.4409 9.55215 26.5677 9.53614 26.76C9.55965 26.9426 9.43598 27.1569 9.41313 27.3382C9.36978 27.4869 9.28457 27.8592 9.16069 27.9521C8.96655 28.3928 8.94326 28.3315 8.81876 28.8347Z"
        fill="#588054"
      />
      <path
        d="M16.3359 46.2802C19.4606 42.4698 22.6026 38.6258 26.217 35.2582C29.8654 31.8569 34.0747 29.2257 38.1935 26.4521C40.5411 24.8709 42.8802 23.298 45.236 21.7251C45.5496 21.5137 45.2709 20.9943 44.9488 21.2141C40.7877 24.0131 36.61 26.7954 32.4486 29.6111C28.3296 32.4015 24.708 35.6767 21.383 39.3872C19.4989 41.4871 17.7059 43.6789 15.9215 45.8622C15.674 46.1573 16.0884 46.5753 16.3359 46.2802Z"
        fill="#4C664A"
      />
      <path
        d="M22.6187 38.6761C22.6171 37.534 22.5068 36.3503 22.1601 35.2685C21.7972 34.1364 21.1116 33.2746 20.3339 32.3879C18.6958 30.5142 17.7178 28.268 17.5581 25.7576C17.5379 25.3798 16.9417 25.3741 16.9701 25.7603C17.1084 27.9936 17.8357 30.1403 19.1727 31.9145C19.9072 32.8938 20.8706 33.7124 21.3678 34.8439C21.8895 36.034 22.0226 37.3939 22.0224 38.6705C22.0258 39.0484 22.622 39.054 22.6187 38.6761Z"
        fill="#4C664A"
      />
      <path
        d="M27.8873 33.4533C27.6809 30.6576 27.2725 27.8964 27.0997 25.1006C26.9418 22.4558 26.9605 19.7851 27.8427 17.2363C27.9735 16.8746 27.4044 16.7261 27.2736 17.0878C26.4001 19.6113 26.3563 22.2738 26.4977 24.9018C26.6612 27.7565 27.077 30.5932 27.291 33.4476C27.3195 33.8338 27.9074 33.8311 27.8873 33.4533Z"
        fill="#4C664A"
      />
      <path
        d="M20.3463 41.5587C21.2648 41.3277 22.1518 41.5756 23.0393 41.7899C23.8514 41.9793 24.6562 42.0932 25.4968 42.0389C27.3125 41.9298 29.0515 41.2667 30.7399 40.6207C31.0944 40.4847 30.9594 39.9058 30.5963 40.0503C28.8488 40.7218 27.0251 41.4356 25.1434 41.4611C23.4801 41.4855 21.8797 40.5691 20.2027 40.9883C19.832 41.074 19.9756 41.6444 20.3463 41.5587Z"
        fill="#4C664A"
      />
      <path
        d="M24.8572 36.457C27.6559 36.3182 30.4461 36.1878 33.2448 36.0489C35.6233 35.9288 38.2583 36.1015 40.4809 35.0751C40.8274 34.9139 40.5402 34.4029 40.1937 34.5641C39.0698 35.0816 37.8667 35.2299 36.6395 35.3027C35.3534 35.3842 34.0677 35.4321 32.7818 35.4968C30.1428 35.6265 27.5038 35.7562 24.8565 35.8775C24.487 35.8792 24.4706 36.4756 24.8572 36.457Z"
        fill="#4C664A"
      />
      <path
        d="M36.8878 26.752C36.33 24.4871 35.7722 22.2221 35.2059 19.9655C35.11 19.5965 34.5369 19.7503 34.6327 20.1193C35.1905 22.3843 35.7483 24.6493 36.3146 26.9058C36.4019 27.2834 36.9751 27.1296 36.8878 26.752Z"
        fill="#4C664A"
      />
      <path
        d="M33.4489 29.5477C34.3928 29.9381 35.3734 30.0932 36.3995 29.9877C37.493 29.8651 38.6091 29.3057 39.7064 29.5274C40.0834 29.6012 40.2422 29.0294 39.8652 28.9556C38.9103 28.7584 38.0075 29.0733 37.0725 29.2707C35.9439 29.5111 34.8105 29.4743 33.7582 29.0256C33.4157 28.8844 33.0981 29.3982 33.4489 29.5477Z"
        fill="#4C664A"
      />
    </svg>
  );
}

GreenLeaf.propTypes = {
  style: PropTypes.object,
};

export default {
  aspectRatio: 62 / 58,
  svg: GreenLeaf,
  title,
};
